import { Button } from '@auctisync/ui';

export function NotFound() {
  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-6 px-6 text-center"
      style={{ background: 'var(--surface)' }}
    >
      <p className="font-mono text-sm tracking-widest" style={{ color: 'var(--text-muted)' }}>
        404
      </p>
      <h1
        className="max-w-xl text-4xl font-bold tracking-tight md:text-5xl"
        style={{ color: 'var(--text)' }}
      >
        That page hasn't been built yet.
      </h1>
      <p className="max-w-md" style={{ color: 'var(--text-muted)' }}>
        auctisync.com is shipping in waves. Head home for what's live today.
      </p>
      <Button asChild size="lg">
        <a href="/">Back to home</a>
      </Button>
    </div>
  );
}
